export default __webpack_public_path__ + "static/grenette-italic-pro-bd9b556028361bb3df8dca4c325bf7dd.woff2";